import formatPrice from "@/core/helpers/formatPrice";
import { RegionIcon } from "@/shared/icons";

type Props = {
  value: number;
};

export default function PlayerMenuPrimialCoin({ value }: Props) {
  return (
    <div className="px-10 mt-2">
      <div
        className="h-[3.25rem] flex items-center gap-2.5 rounded-[0.625rem] px-4"
        style={{
          background:
            "linear-gradient(90deg, rgba(215, 52, 52, 0.20) 0%, rgba(24, 24, 24, 0.00) 50%, rgba(24, 24, 24, 0.00) 100%)",
        }}
      >
        <RegionIcon size={20} />
        <div className="text-11 font-bold">ПРЕМИАЛЬНАЯ ВАЛЮТА:</div>
        <div className="text-accent-solid text-15 font-bold ml-auto">{formatPrice(value)}</div>
      </div>
    </div>
  );
}
